// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"a4b2baa0","305":"d60e85cf","353":"f19f7224","453":"a5ac7fb3","460":"1dc49571","779":"092a52e6","886":"bbe33907"}[chunkId] + ".chunk.js";
};